<div class="modal-header pb-0">
    <button class="button-close mb-2" mat-button [mat-dialog-close]="false">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path
                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" />
        </svg>
    </button>
</div>

<mat-dialog-content>
    <div class="d-flex align-items-center mb-3 justify-content-center">
        <h2 mat-dialog-title class="m-0">Valor Portal Guide</h2>
    </div>
    <ol>
        <li>
            <strong>Login:</strong>
            <ul>
                <li>Go to the Valor Portal.</li>
                <li>Enter your username and password to log in.</li>
                <li>(If you don’t have an account, register first.)</li>
            </ul>
        </li>
        <li>
            <strong>Navigate to Settings:</strong>
            <ul>
                <li>Once logged in, look at the left-hand sidebar menu.</li>
                <li>Click on <strong>Settings</strong>.</li>
            </ul>
        </li>
        <li>
            <strong>Open the Webhook Tab:</strong>
            <ul>
                <li>In the Settings section, find the <strong>Webhook</strong> tab and click on it.</li>
            </ul>
        </li>
        <li>
            <strong>Add a Webhook:</strong>
            <ul>
                <li>Enter the Webhook URL:
                    <code>{{url}}</code></li>
                <li>Enable the toggle for the webhook.</li>
                <li>
                    Select the required actions for entities like:
                    <ul>
                        <li><strong>USER:</strong> ADD, UPDATE, DELETE</li>
                        <li><strong>TRANSACTION:</strong> ADD, APPROVED</li>
                        <li><strong>RECURRING:</strong> ADD, UPDATE</li>
                    </ul>
                </li>
            </ul>
        </li>
        <li>
            <strong>Save:</strong>
            <ul>
                <li>Once all configurations are done, click <strong>Save</strong> to apply your webhook settings.</li>
            </ul>
        </li>
    </ol>
</mat-dialog-content>


<mat-dialog-actions>
    <!-- <button mat-button mat-dialog-close>Close</button> -->
</mat-dialog-actions>